module.exports = __webpack_public_path__ + "media/03.5aaf4a8c.mp4";